module.exports = __webpack_public_path__ + "img/crystal.c6953e8.webp";